/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

// Component imports
import { Form } from 'antd';
import LabelWithOriginalText from '../../../Forms/Fields/LabelWithOriginalText';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';
import { ACTIVITY_TYPES, VARIABLE_TYPES } from '../../../../constants/main';
import { getCurrentQueryState } from '../../../../store/utils/getCurrentQueryState';
import RichTextEditor from '../../../Forms/Fields/RichTextEditor/RichTextEditor';

const StickyNoteNodeForm = ({ form }) => {
  const { orgId, tenantId } = useParams();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const { isEditingPrimaryLanguage, botLanguages, currentBotLanguage, primaryBotLanguage } = useBotLanguage();

  const { data: activity } = getCurrentQueryState('fetchActivity', { orgId, tenantId, activityId: searchParams.get('activity'), currentBotLanguage }, !searchParams.get('activity'));

  return (
    <Fragment>
      {/* Sticky note message */}
      <LabelWithOriginalText label={t('Note')} originalText={form.getFieldValue(['data', 'label', primaryBotLanguage])} />
      {
        botLanguages.map(lang => (
          <Form.Item
            label=""
            name={['data', 'label', lang]}
            hidden={currentBotLanguage !== lang}
            rules={[{ required: lang === primaryBotLanguage && isEditingPrimaryLanguage, message: t('Message cannot be blank.') }]}
          >
            <RichTextEditor
              placeholder={t('Write some content')}
              includedVariableTypes={activity?.type === ACTIVITY_TYPES.LIVECHAT_FLOW ? [VARIABLE_TYPES.LIVECHAT] : []}
            />
          </Form.Item>
        ))
      }
      {/* ./ Sticky note message */}
    </Fragment>
  );
};

StickyNoteNodeForm.propTypes = {
  form: PropTypes.object.isRequired
};

export default StickyNoteNodeForm;
